import { z } from 'zod';

/* Evento realtime do BACKOFFICE de staff (TASK-PUB-50). Broadcast unidirecional
   (server→client) via `StaffNotifyDO` (sala global única de staff). Sinal magro: a fila de
   moderação mudou (nova submissão OU decisão de qualquer staff) → o admin-web invalida a
   query da fila e refetcha. A verdade é o Postgres; o evento só dispara o refetch, então não
   carrega o payload da submissão (evita divergência de cache e vazamento entre staff). */
export const staffNotifyEvent = z.object({
  type: z.literal('queue_changed'),
});
export type StaffNotifyEvent = z.infer<typeof staffNotifyEvent>;
